import { create, type StateCreator } from 'zustand'
import { devtools, persist } from 'zustand/middleware'

export interface FullWithUiSlice {
    fullWidthUi: boolean
}

export const createFullWidthUiSlice: StateCreator<FullWithUiSlice, [], [], FullWithUiSlice> = () => ({
    fullWidthUi: false,
})

export const useFullWidthUiStore = create<FullWithUiSlice>()(
    persist(
        devtools(createFullWidthUiSlice as any, {
            name: 'FullWidthUiStore',
        }),
        { name: 'full-width-ui' },
    ),
)

export const useFullWidthUi = () => useFullWidthUiStore((state) => state.fullWidthUi)
export const getFullWidthUiState = () => useFullWidthUiStore.getState().fullWidthUi
export const setFullWidthUi = (state: boolean) => useFullWidthUiStore.setState({ fullWidthUi: state })
export const toggleFullWidthUi = () => setFullWidthUi(!getFullWidthUiState())
